export default function(newDoc, oldDoc, userCtx) {
  if (userCtx.name === "admin") {
    return;
  }

  if (userCtx.roles.indexOf("{}__admin") === -1) {
      throw({forbidden: "Você não tem autorização para realizar esta alteração."});
  }
  
  if (newDoc.calibracoes) {
    var HoraInicial
    var HoraInicialAnterior = Infinity
    if (Object.prototype.toString.call(newDoc["calibracoes"]) !== "[object Array]") {
      throw({forbidden: "O campo calibracoes deve conter uma lista."});
    }

    ["descricao","empresa","fabricante","identificacao","modelo","numeroserie","patrimonio"].map(function(k) {
      if (typeof newDoc[k] !== "string") {
        throw({forbidden: "O campo "+k+" deve ser texto."});
      }
    })

    newDoc["calibracoes"].map(function(cal) {
      if (Object.prototype.toString.call(cal["Faixas"]) !== "[object Array]") {
        throw({forbidden: "O campo Faixas deve conter uma lista."});
      }
      ["Certificado", "HoraInicial"].map(function(k) {
        if (typeof cal[k] !== "string") {
          throw({forbidden: "O campo "+k+" deve ser texto."});
        }
      })

      if (cal["HoraInicial"].indexOf("T") !== -1) {
        HoraInicial = Date.UTC.apply(undefined, cal["HoraInicial"].split("T")[0].split("-"))
      } else {
        HoraInicial = Date.UTC.apply(undefined, cal["HoraInicial"].split(" ")[0].split("-"))
      }

      if (isNaN(HoraInicial) || typeof HoraInicial !== "number") {
        throw({forbidden: "Formato inválido para HoraInicial"});
      }

      if (HoraInicial > HoraInicialAnterior) {
        throw({forbidden: "A ordem das calibracoes deve ser decrescente."});
      }
      HoraInicialAnterior = HoraInicial

      cal["Faixas"].map(function(faixa) {
        if (Object.prototype.toString.call(faixa["series"]) !== "[object Array]") {
          throw({forbidden: "O campo calibracoes deve conter uma lista."});
        }
        ["CodigoFaixaModelo", "DescFaixa", "Freq", "FreqPrefixo", "Prefixo", "Unidade"].map(function(k) {
          if (typeof faixa[k] !== "string") {
            throw({forbidden: "O campo "+k+" deve ser texto."});
          }
        })
        faixa["series"].map(function(serie) {
          ["cod", "nome"].map(function(k) {
            if (typeof serie[k] !== "string") {
              throw({forbidden: "O campo "+k+" deve ser texto."});
            }
            if (Object.prototype.toString.call(serie["data"]) !== "[object Object]") {
              throw({forbidden: "O campo serie.data deve conter uma objeto."});
            }
            ["ErroMaximoFaixa", "ErroMinimoFaixa", "IncertExpandidaUsada", "ResultadoMedicao", "Valor", "ValorDoInstrumento", "ValorDoPadrao", "fatork"].map(function(dataKey) {
              if (Object.prototype.toString.call(serie["data"][dataKey]) !== "[object Array]") {
                throw({forbidden: "O campo "+dataKey+" deve conter uma lista."});
              }
              serie["data"][dataKey].map(function(val) {
                if (typeof val !== "number") {
                  throw({forbidden: "Os valores de "+dataKey+" devem ser numéricos."});
                }
              })
            })
          })
        })
      })
    })
  }


  if (newDoc.type && newDoc.type.split("_")[0] === "config") {

    if (typeof newDoc.autor !== "string" || typeof newDoc.timestamp !== "number") {
      throw({forbidden: "Formato incorreto"});
    }

    if (newDoc.periodicidade && (typeof newDoc.periodicidade.suffixo !== "string" || typeof newDoc.periodicidade.val !== "number")) {
      throw({forbidden: "Formato incorreto"});
    }

    if (typeof newDoc.timestamp !== "number") {
      throw({forbidden: "Formato incorreto"});
    }

    if (newDoc._id.indexOf("_config_") === -1) {
      throw({forbidden: "Formato incorreto"});
    }
  }

}